import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom"
import Select from 'react-select';
import { getApi } from '../Admin Master/Area Control/Zonemaster/ServicesApi';
function DocketPrint2() {
    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({
        from: "",
        to: "",
        Branch_Code:"",
    })
    const location = useLocation();
    console.log(formData);
    const navigate = useNavigate();
    
    const handleFormChange = (value, key) => {
        setFormData({ ...formData, [key]: value });
    }
     const [getBranch, setGetBranch] = useState([]);

     
         const fetchBranchData = async () => {
                  try {
                                 const response = await getApi(
                                             `/Master/GetAllBranchData?Branch_Code=${JSON.parse(localStorage.getItem('Login'))?.Branch_Code}`
                                         );
                                 
                                         let data = Array.isArray(response.Data) ? response.Data : [];
                                 
                                         // ✅ REMOVE ALB
                                         const filteredData = data.filter(
                                             (item) => item.Branch_Code !== 'ALB'
                                         );
                             
                                 setGetBranch(filteredData);
                             } catch (err) {
                                 console.error('Fetch Error:', err);
                         
                             } 
         };
     
         useEffect(()=>{
             fetchBranchData();
         },[])

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!formData.Branch_Code || !formData.from || !formData.to)
                {
                    return Swal.fire("Warning", `All Fields required`, "warning");
                }
        try {
            
            const response = await getApi(`/Booking/DocketPrint_2?FromDocket=${formData.from}&ToDocket=${formData.to}`);
            if (response.status === 1) {
                console.log(response);
                console.log(response.Data);
                setData(response.Data);
                response.Data && navigate("/vendorboxlabel", { state: { data: response.Data, path: location.pathname ,tab:"print2"} });
            }
            else {
                Swal.fire("Warning", `Warong Docket Number`, "warning");
            }
        }
        catch (error) {
            console.error("API Error:", error);
        }
        finally {
        }
    }
    return (
        <>
            <div className="container1">
                <form onSubmit={handleSubmit} style={{backgroundColor:"#f2f4f3"}}>
                    <div className="fields2">

                        <div className="input-field3">
                                                                            <label htmlFor="">Brnach Name</label>
                                                                            <Select
                                                                                className="blue-selectbooking"
                                                                                classNamePrefix="blue-selectbooking"
                                                                                options={getBranch.map((branch) => ({
                                                                                    value: branch.Branch_Code,
                                                                                    label: branch.Branch_Name,
                                                                                }))}
                                                                                value={
                                                                                    formData.Branch_Code
                                                                                        ? {
                                                                                            value: formData.Branch_Code,
                                                                                            label:
                                                                                                getBranch.find((b) => b.Branch_Code === formData.Branch_Code)
                                                                                                    ?.Branch_Name || "",
                                                                                        }
                                                                                        : null
                                                                                }
                                                                                onChange={(selected) =>
                                                                                    setFormData({
                                                                                        ...formData,
                                                                                        Branch_Code: selected ? selected.value : "",
                                                                                    })
                                                                                }
                                                                                placeholder="Branch Name"
                                                                                isSearchable={true}
                                                                                isClearable={false}
                                                                                menuPortalTarget={document.body}
                                                                                styles={{
                                                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                                }}
                                                                            />
                        
                                                                        </div>

                        <div className="input-field3">
                            <label htmlFor="">From</label>
                            <input type="text" placeholder='From Docket' value={formData.from} onChange={(e) => handleFormChange(e.target.value, "from")} />
                        </div>
                        <div className="input-field3">
                            <label htmlFor="">To</label>
                            <input type="text" placeholder='To Docket' value={formData.to} onChange={(e) => handleFormChange(e.target.value, "to")} />
                        </div>



                        <div className="bottom-buttons" style={{ marginTop: "22px", marginLeft: "12px" }}>
                            <button type='submit' className='ok-btn'>Submit</button>
                            <button className='ok-btn'>Cancel</button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}

export default DocketPrint2;